import { useUiLanguage } from "@/i18n/useUiLanguage";
import { tr } from "@/i18n/copy";
import { useEffect, useState } from "react";
import { api, errMsg } from "@/lib/api";
import EconomicLedgerPanel from "@/components/EconomicLedgerPanel";
import ProfessionalAgreements from "@/components/ProfessionalAgreements";

export default function ArtistFinancePanel() {
  useUiLanguage();
  const [profile,setProfile]=useState(null),[error,setError]=useState("");
  useEffect(()=>{const load=()=>api.get("/artist-self/me").then(setProfile).catch(e=>setError(errMsg(e)));load();window.addEventListener("tps:data-changed",load);return()=>window.removeEventListener("tps:data-changed",load);},[]);
  if(!profile)return <p>{error||tr("Caricamento rendiconto…")}</p>;
  return <div className="space-y-4"><EconomicLedgerPanel artist={profile}/><ProfessionalAgreements artist={profile}/><p className="text-xs text-muted-foreground">{tr("Riporta i compensi distinti per attività nella piattaforma esterna di fatturazione. TPS registra i conteggi e la tua conferma del pagamento ricevuto dallo Studio.")}</p></div>;
}
